import React from 'react';
import { Group, Text } from '@mantine/core';

type Props = {
  onLoadPrev: () => void;
  onLoadNext: () => void;
  onBack: () => void;
};

export const ThreadActions = React.memo(({ onLoadPrev, onLoadNext, onBack }: Props) => (
  <Group justify="space-between">
    <Text
      size="sm"
      style={{ textDecoration: 'underline', cursor: 'pointer', color: 'var(--quo-blue-80)' }}
      onClick={onLoadPrev}
    >
      Load previous 25 messages
    </Text>
    <Text
      size="sm"
      style={{ textDecoration: 'underline', cursor: 'pointer', color: 'var(--quo-blue-80)' }}
      onClick={onBack}
    >
      Bring back to the mention
    </Text>
    <Text
      size="sm"
      style={{ textDecoration: 'underline', cursor: 'pointer', color: 'var(--quo-blue-80)' }}
      onClick={onLoadNext}
    >
      Load next 25 messages
    </Text>
  </Group>
));
